export default "__VITE_ASSET__BWvPHjf2__"